import React, { useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ScrollToTop from "../component/ScrollToTop";
export default function Contact() {
  const [input, setInput] = useState({
    fname: "",
    email: "",
    country: "",
    state: "",
    city: "",
    mobile: "",
    message: "",
  });
  const [verror, setVerror] = useState("");
  const [validations, setValidations] = useState({
    fname: false,
    email: false,
    country: false,
    state: false,
    city: false,
    mobile: false,
    message: false,
  });

  const validationRules = {
    fname: "First name is required",
    email: "Email is required",
    country: "Country name is required",
    state: "State name is required",
    city: "City name is required",
    mobile: "Mobile is required",
    message: "Message is requied",
  };

  const handelInputs = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
    setValidations({ ...validations, [name]: false });
  };
  const handelSubmit = () => {
    for (const field in input) {
      if (!input[field]) {
        setValidations({ ...validations, [field]: true });
        setVerror(validationRules[field]);
        return;
      }
      const MOBILE_REGX = /^[0-9]{10}$/;
      const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (field === "email" && !EMAIL_REGEX.test(input.email)) {
        setValidations({ ...validations, email: true });
        setVerror("Valid Email Required.");
        return;
      }
      if (field === "mobile" && !MOBILE_REGX.test(input.mobile)) {
        setValidations({ ...validations, mobile: true });
        setVerror("Valid Mobile Required.");
        return;
      }
    }
    console.log(input);
    setInput({
      fname: "",
      email: "",
      country: "",
      state: "",
      city: "",
      mobile: "",
      message: "",
    });
  };
  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="section_padding bg-black hero_padding hero_padding">
          <div className="container ">
            <div className="row py-md-5 py-3 mt-lg-0 mt-md-5 mt-0 g-lg-4 g-3 align-items-center">
              <div className="col-xl-5 col-lg-7">
                <h1 className="heading-1 mb-xl-5 mb-3">
                  Let's Initiate Your Project Repository
                </h1>
                <p className="font_14 text-white">
                  Drop us a line and one of our techies will be in touch with
                  you.
                </p>
              </div>
              <div className="col-xl-4 col-12 offset-xl-2">
                <div className="row gy-1 gx-3 needs-validation" noValidate="">
                  <div className="col-md-6">
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className={
                          validations.fname && verror
                            ? "form-control rounded-left my-1"
                            : "form-control rounded-left mb-3"
                        }
                        id="firstName"
                        placeholder="First Name"
                        required=""
                        name="fname"
                        value={input.fname}
                        onChange={handelInputs}
                      />
                      <label htmlFor="firstName">First Name</label>
                      {validations.fname && verror && (
                        <>
                          <p className="d-flex my-1 error_message font_16">
                            <img
                              src="assets/images/contact/warning.svg"
                              alt=""
                              className="me-1"
                            />
                            {verror}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        placeholder="Last Name"
                        required=""
                      />
                      <label htmlFor="lastName">Last Name</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="name@example.com"
                        required=""
                      />
                      <label htmlFor="email">Email address</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating mb-3">
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        placeholder="Phone Number"
                        required=""
                      />
                      <label htmlFor="phone">Phone Number</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a comment here"
                        id="message"
                        rows={4}
                        required=""
                        defaultValue={""}
                      />
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>
                  <div className="col-12 mt-lg-4 mt-3">
                    <button
                      className="btn blockcryp_button font_14 fw-bold w-100
                      rounded"
                      onClick={handelSubmit}
                    >Submit</button>
                   
                  </div>
                  <p className="contact_para mt-4 font_14">
                    By submitting, you consent to Mindevolved processing your
                    information in accordance with our Privacy Policy. We take
                    your privacy seriously. You can opt out of email updates at
                    any time. This site is protected by reCAPTCHA and the Google
                    Privacy Policy and Terms of Service apply.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section_padding location_bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <h2 className="heading-2 text-white">
                  In your time zone, available anywhere
                </h2>
                <p className="sub_para contact_para">
                  When deploying your applications and workloads to the
                  cloud,our engineers have the flexibility to work in timezones
                  closest to your region,ensuirng stable deliveries 365 days a
                  year.
                </p>
              </div>
              <div className="col-lg-8">
                {/* <img src="assets/63f7bc76e735b5f53dc0e50e_location-map@2x.png" alt="" className="img-fluid" /> */}
              </div>
            </div>
            <div className="row g-lg-5 g-3 mt-5">
              <div className="col-lg-3 col-md-6 text-white">
                <h4 className="heading-4 mb-lg-3 mb-2 fw-bold">Australia</h4>
                <p className="font_14 mb-lg-3 mb-2">Sydney</p>
                <p className="sub_para contact_para">
                  Level 38 1 Farrer Place, Sydeny NSW 2000 Australia
                </p>
              </div>
              <div className="col-lg-3 col-md-6 text-white">
                <h4 className="heading-4 mb-lg-3 mb-2 fw-bold">Malaysia</h4>
                <p className="font_14 mb-lg-3 mb-2">Kuala Lumpur</p>
                <p className="sub_para contact_para">
                  50250 Kuala Lumpur,Wilayah Persekutuan Kuala Lumpur ,Malaysia
                </p>
              </div>
              <div className="col-lg-3 col-md-6 text-white">
                <h4 className="heading-4 mb-lg-3 mb-2 fw-bold">Uae</h4>
                <p className="font_14 mb-lg-3 mb-2">Dubai</p>
                <p className="sub_para contact_para">
                  Level 3,The Office 3,One Central Dubai World -Trade Center
                  Dubai,UAE
                </p>
              </div>
              <div className="col-lg-3 col-md-6 text-white">
                <h4 className="heading-4 mb-lg-3 mb-2 fw-bold">USA</h4>
                <p className="font_14 mb-lg-3 mb-2">Palo Alto</p>
                <p className="sub_para contact_para">
                  2100 Geng Rd Suit 210 Palo Alto,CA 94303,USA
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding section">
          <div className="container">
            <div className="row justify-content-center my-xl-5 my-4">
              <div className="col-lg-6 text-center">
                <img
                  src="assets/img/639b830a4cbdd20fd5f3a9a9/63a37b076fcebf5f2b1bc482_MindEvolved_symbol@3x.png"
                  alt="img"
                  className="mb-4 repo_img"
                />
                <h2 className="sub_title text-white mb-xl-4 mb-3">
                  Let's initiate your <br /> project repository
                </h2>
                <p className="sub_para body-regular mb-xl-5">
                  Get in touch with our team today to discuss how we can help
                  your business <br /> spot opportunities and realise potential.
                </p>
                <a href="" className="btn blockcryp_button font_14 fw-bold">
                  Contact
                </a>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </ScrollToTop>
    </>
  );
}
